/** Statsig kill switch for learner contract extension UI (banner + renewal bell). */
export const ENTERPRISE_LEARNER_CONTRACT_EXTENSION_GATE = 'enterprise-learner-contract-extension';
